import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { AdministratorService } from '../../../services/administrator.service';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from '../../loader/loader.component';
import { gridPageRequest, gridPagination, User, userGridResponse } from '../../../model/common/common.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { projectGridResponse } from '../../../model/inventory.model';

@Component({
  selector: 'app-user-list',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent],
  templateUrl: './user-list.component.html',
  styleUrl: './user-list.component.scss'
})
export class UserListComponent implements OnInit {
  @ViewChild('dt1') dt1: Table | undefined;

  constructor(private messageService: MessageService, private administratorService: AdministratorService, private route: Router, private confirmationService: ConfirmationService,) { }

  userList: any[] = []
  searchKey: any;
  selecteduser: User[] = [];
  roleData: any;
  loader: boolean = false;

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 10
  }

  result: userGridResponse = {
    users: [],
    totalRecords: 0
  }

  ngOnInit(): void {
    document.title = 'User List';
    this.getUserList();
    this.searchEffect();
  }

  createUser() {
    this.route.navigate(['/home/userRegistration'])
  }

  updateUser(data?: any) {
    if (data) {
      this.route.navigate(['/home/userRegistration'], { queryParams: { 'userId': data }, skipLocationChange: true },);
    } else {
      this.route.navigate(['/home/userRegistration'], { queryParams: { 'userId': this.selecteduser[0].userId }, skipLocationChange: true },);
    }
  }

  deleteUser() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        this.loader = true;
        if (this.selecteduser && this.selecteduser.length > 0) {
          const userIds = this.selecteduser.map(bom => bom.userId);
          this.administratorService.deleteUser(userIds).subscribe({
            next: data => {
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'user deleted successfully.' });
              this.loader = false;
              this.selecteduser = [];
              setTimeout(() => {
                this.getUserList();
              }, 2000);
            },
            error: error => {
              this.loader = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to delete user.' });
            }
          });
        }
      },
      reject: () => {
      }
    });
  }

  searchuser() {
    if (!this.searchKey) {
      return;
    }
    if (this.dt1) {
      this.dt1.first = 0;
    }
    this.administratorService.autoSearchUserInfo(this.searchKey).subscribe(
      (data: any) => {
        if (data) {
          this.userList = data;
          if (this.dt1) {
            this.dt1.first = 0;
          }
        } else {
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }


  getUserList(): void {
    // this.loader = true;
    this.administratorService.getAllUser().subscribe({
      next: (data: any) => {

        this.userList = data;

        // this.loader = false;
      },
      error: error => {
        console.error('Error fetching user info:', error);
        // this.loader = false;
      }
    });
  }


  load(event: any) {
    if (this.searchKey && this.searchKey.trim() !== '') {
      this.searchuser();
    } else {
      this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
      this.getUserList();
    }
  }

  refreshData(): void {
    if (this.dt1) {
      this.dt1.first = 0;
      this.dt1.clear();
    }
    this.searchKey = '';
    this.pageRequest.pageIndex = 0;
    this.pageRequest.pageSize = 50;
    this.getUserList();
  }

  
  placeholder: string = 'Search By ';
  private messages: string[] = ['User Name'];
  private messageIndex = 0;
  private charIndex = 0;


  searchEffect() {
    const base = 'Search By ';
    const typeNextChar = () => {
      if (this.charIndex <= this.messages[this.messageIndex].length) {
        this.placeholder = base + this.messages[this.messageIndex].substring(0, this.charIndex);
        this.charIndex++;
        setTimeout(typeNextChar, 150);
      } else {
        setTimeout(() => {
          this.messageIndex = (this.messageIndex + 1) % this.messages.length;
          this.charIndex = 0;
          typeNextChar();
        }, 1000);
      }
    };
    typeNextChar();
  }

}
